module.exports = __webpack_public_path__ + "static/media/whisky-logo.c93f7c77.png";